import { ActionReducer, MetaReducer } from '@ngrx/store';
import { resetStore } from './app.actions';

export function resetStoreMetaReducer(
  reducer: ActionReducer<unknown>,
): ActionReducer<unknown> {
  return (state, action) => {
    if (action.type === resetStore.type) {
      return reducer(undefined, action);
    }
    return reducer(state, action);
  };
}

export const metaReducers: MetaReducer[] = [resetStoreMetaReducer];

